import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmCheckIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmCheckIcon = ({ className, ...props }: EmCheckIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_286_34267)">
      <path
        d="M20.0166 0.680634H2.1416C1.38191 0.680634 0.766602 1.29595 0.766602 2.05563V19.9306C0.766602 20.6903 1.38191 21.3056 2.1416 21.3056H20.0166C20.7763 21.3056 21.3916 20.6903 21.3916 19.9306V2.05563C21.3916 1.29595 20.7763 0.680634 20.0166 0.680634Z"
        fill="#689F38"
      />
      <path
        d="M18.9338 0.680634H2.05567C1.34582 0.68579 0.771762 1.25985 0.766605 1.9697V18.7963C0.764887 19.5078 1.34067 20.0836 2.05223 20.0853C2.05395 20.0853 2.05395 20.0853 2.05567 20.0853H18.9166C19.6282 20.087 20.2039 19.5113 20.2057 18.7997C20.2057 18.798 20.2057 18.798 20.2057 18.7963V1.9697C20.2211 1.2736 19.6677 0.696102 18.9716 0.680634C18.9596 0.680634 18.9458 0.680634 18.9338 0.680634Z"
        fill="#7CB342"
      />
      <path
        d="M6.90256 2.21032C6.90256 1.81501 6.62756 1.6947 5.04631 1.74626C3.72288 1.79782 3.06975 1.95251 2.67444 2.43376C2.27913 2.91501 2.176 3.8947 2.15881 5.06345C2.15881 5.88845 2.15881 6.66189 2.5885 6.66189C3.17288 6.66189 3.17288 5.30407 3.65413 4.54782C4.58225 3.05251 6.90256 2.72595 6.90256 2.21032Z"
        fill="white"
        opacity="0.3"
      />
      <path
        d="M7.43527 18.8134C6.75464 18.8323 6.14449 18.3975 5.93996 17.7478L3.34464 9.92748C3.0937 9.10077 3.56121 8.22592 4.38792 7.97499C5.18714 7.73264 6.0362 8.16061 6.31808 8.9478L8.00246 14.0181L16.0978 3.77436C16.634 3.09545 17.6189 2.9803 18.2978 3.51655C18.9767 4.0528 19.0918 5.03764 18.5556 5.71655L8.65558 18.2119C8.36167 18.5883 7.91308 18.81 7.43527 18.8134Z"
        fill="#FBF9F9"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_34267">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmCheckIcon;
